import { SECONDS_TO_HOURS } from '@AccessRightSizing/common/common';
import {
  DURATION_METRIC,
  METRIC_TYPE_LABELS,
  MetricType,
  TOTAL_REQUESTS_METRIC,
} from '@AccessRightSizing/common/constants';
import { AccessFlowUsageMetricValue_FragmentFragment } from '@api/gql/graphql';

export const getLabel = (key: string): string => {
  if (key in METRIC_TYPE_LABELS) {
    return METRIC_TYPE_LABELS[key as MetricType];
  }
  return 'Unknown metric type';
};

export function getTrendStats(
  metricType: string,
  current: AccessFlowUsageMetricValue_FragmentFragment,
  previous: AccessFlowUsageMetricValue_FragmentFragment,
): { changeValue: number; changePercentage: number } {
  const getValue = (metric: AccessFlowUsageMetricValue_FragmentFragment) =>
    metricType === TOTAL_REQUESTS_METRIC ? metric.defined : metric.notUsed;

  const currentValue = getValue(current);
  const previousValue = getValue(previous);

  let changeValue = currentValue - previousValue;
  const changePercentage = previousValue !== 0 ? (changeValue / previousValue) * 100 : 100;

  if (metricType === DURATION_METRIC && changeValue !== 0) {
    changeValue = changeValue / SECONDS_TO_HOURS;
  }

  return {
    changeValue: Number(changeValue.toFixed(2)),
    changePercentage: changeValue === 0 ? 0 : Number(changePercentage.toFixed(0)),
  };
}

export function getMainValue(metricType: string, current: AccessFlowUsageMetricValue_FragmentFragment): string {
  if (metricType === TOTAL_REQUESTS_METRIC) {
    return current.defined.toString();
  }

  if (current.defined === 0) return '-';

  const ratio = current.notUsed / current.defined;

  if (metricType === DURATION_METRIC) {
    const value = ratio !== 0 ? (1 - ratio) * 100 : 0;
    return value > 100 || value < 0 ? '-' : `${value.toFixed(1)}%`;
  }

  if (ratio > 1) return '-';
  return `${(ratio * 100).toFixed(1)}%`;
}
